import axios from "axios";

const url = process.env.REACT_APP_BASE_API_URL;

export const clienteFindAll = async () => {
    const headers = { "Content-Type": "application/json" };
    return await axios.get(url + "/v1/cliente/findall", { headers });
};

export const clienteInsert = async (cliente) => {
    console.log("------> cliente--", cliente);
    const headers = { "Content-Type": "application/json" };
    return await axios.post(url + "/v1/cliente/insert", cliente, { headers });
};

export const clienteUpdate = async (cliId, body) => {
    // const headers = { "Content-Type": "application/json" };
    return await axios.put(url + "/v1/cliente/update/" + cliId, body);
};

export const clienteDelete = async (cliente) => {
    const headers = { "Content-Type": "application/json" };
    return await axios.delete(url + "/v1/cliente/delete/" + cliente, { headers });
};

export const clienteFindAllByUsuId = async () => {
    const headers = { "Content-Type": "application/json" };
    return await axios.get(url + "/v1/cliente/findallbyusuid", {
        headers,
    });
};
